module.exports = __webpack_public_path__ + "img/DFW_StoneSword.4eb629e2.png";